import React from 'react';
import {arrayOf, bool, func, number, object, shape, string} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {Container, Icon, Table} from 'semantic-ui-react';
import FailureDisplay from './FailureDisplay';
import {formatDateTime} from '../../utils';
import PagingBar from "../../../../components/common/PagingBar";
import {pageCount} from "../../../../utils/DBUtils";

const toCurrencyIfNumber = (val) => {
    let num = parseFloat(val);
    if (!isNaN(num)) {
        return `$ ${num.toFixed(2)}`
    }

    return val;
};

const UserStorePage = props => {
    if (props.ajaxError) {
        return <FailureDisplay labelKey='userManagement.userDetail.panes.store.ajaxError'/>;
    }

    return (
        <React.Fragment>
            <PagingBar count={pageCount(props.totalOrders, props.pageSize)}
                       currentPage={props.currentPage}
                       onPageSelected={(i) => props.fetchStoreOrdersPage(props.user.id, i)}
                       onNextClicked={() => props.fetchStoreOrdersPage(props.user.id, props.currentPage + 1)}
                       onPreviousClicked={() => props.fetchStoreOrdersPage(props.user.id, props.currentPage - 1)}
                       maxPages={10}
                       total={props.totalOrders}
                       numOfItemsOnPage={props.pageSize}
            />
            {props.isLoading ? (
                <Container textAlign='center'>
                    <Icon loading name='spinner' size='huge'/>
                </Container>
            ) : (
                props.prizeboothOrders.length === 0 ? (
                    <p><FormattedMessage id='userManagement.userDetail.panes.store.empty'/></p>
                ) : (
                    <React.Fragment>
                        <Table striped>
                            <Table.Header className='white-header'>
                                <Table.HeaderCell></Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.dateCreated'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.offerPartner'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.offerName'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.offerType'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.cost'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.refunded'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.orderId'/>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <FormattedMessage id='userManagement.userDetail.panes.store.offerId'/>
                                </Table.HeaderCell>
                            </Table.Header>
                            <Table.Body>
                                {props.prizeboothOrders.map(order => (
                                    <Table.Row>
                                        <Table.Cell>
                                            <Link to='https://www.dailybreak.com/prizebooth/store' target='_blank'>
                                                <Icon name='search'/>
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>{formatDateTime(order.dateCreated)}</Table.Cell>
                                        <Table.Cell>{order.offerPartner}</Table.Cell>
                                        <Table.Cell>{toCurrencyIfNumber(order.offerName)}</Table.Cell>
                                        <Table.Cell>{order.offerType}</Table.Cell>
                                        <Table.Cell>{order.cost}</Table.Cell>
                                        <Table.Cell>{order.refunded ? formatDateTime(order.refunded) : ''}</Table.Cell>
                                        <Table.Cell>{order.orderId}</Table.Cell>
                                        <Table.Cell>{order.offerId}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </React.Fragment>
                )
            )}
        </React.Fragment>

    );
};

export const PrizeboothOrderPropType = shape({
    code: string,
    cost: number.isRequired,
    dateCreated: object.isRequired,
    offerId: number.isRequired,
    offerName: string.isRequired,
    offerPartner: string.isRequired,
    offerType: string.isRequired,
    orderId: string.isRequired,
    refunded: object
});

UserStorePage.propTypes = {
    prizeboothOrders: arrayOf(PrizeboothOrderPropType),
    isLoading: bool.isRequired,
    ajaxError: object,
    orderCount: number,
    currentPage: number,
    fetchStoreOrdersPage: func,
    totalOrders: number,
    pageSize: number
};

export default UserStorePage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserStorePage.jsx